export default [
  {
    path: '/base-data',
    name: 'base-data.index',
    component: require('./index').default,
    meta: {
      title: '基础数据',
      navbar: 'el-icon-data-line'
    }
  }
]
